module.exports = __webpack_public_path__ + "static/media/accessibilityNew.d6a3d2f3.svg";